"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const AccessData_1 = __importDefault(require("@becrop/components/Profile/Access/class/models/AccessData"));
const PreTable_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/PreTable.vue"));
const MainTable_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/MainTable.vue"));
const TableProjects_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/TableProjects.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let MainView = class MainView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.samplesIds = [];
        this.projectsIds = [];
        this.isResetItemsCheck = false;
        this.textSearch = '';
        this.cropsIdsFilters = [];
        this.filterAccess = '';
    }
    recall() {
        this.$emit('recall');
    }
    mounted() {
        this.dataSet.setCurrentPage(1, 'projects');
        this.dataSet.setCurrentPage(1, 'samples');
    }
    get paginationInfo() {
        return {
            totalPages: this.dimension === 'samples'
                ? this.dataSet.samplesTotalPages
                : this.dataSet.projectsTotalPages,
        };
    }
    loadPage(page) {
        this.dataSet.setCurrentPage(page, this.dimension);
    }
    updateFilterAccess(filterAccess) {
        this.filterAccess = filterAccess;
        this.cropsIdsFilters = [];
        this.resetItemsCheck();
        this.samplesIds = [];
        this.projectsIds = [];
    }
    updateCropsIdsFilters(filters) {
        this.cropsIdsFilters = filters;
        this.filterAccess = '';
        this.resetItemsCheck();
        this.samplesIds = [];
        this.projectsIds = [];
    }
    updateTextSearch(newFilter) {
        this.textSearch = newFilter;
        this.resetItemsCheck();
        this.samplesIds = [];
        this.projectsIds = [];
        this.filterAccess = '';
        this.cropsIdsFilters = [];
    }
    resetItemsCheck() {
        this.isResetItemsCheck = !this.isResetItemsCheck;
    }
    newDimension(newDimension) {
        this.samplesIds = [];
        this.projectsIds = [];
        this.cropsIdsFilters = [];
        this.filterAccess = '';
        if (this.dimension === 'samples') {
            this.dataSet.setCurrentPage(1, 'projects');
        }
        else {
            this.dataSet.setCurrentPage(1, 'samples');
        }
        this.$emit('newDimension', newDimension);
    }
    f() {
        this.dataSet.setCurrentPage(1, 'projects');
        this.dataSet.setCurrentPage(1, 'samples');
    }
    getSamplesIds(samplesIds) {
        this.samplesIds = samplesIds;
    }
    getProjectsIds(projectsIds) {
        this.projectsIds = projectsIds;
    }
    individualProjectRevoke(data) {
        this.$emit('individualProjectRevoke', data);
    }
    individualSampleRevoke(data) {
        this.$emit('individualSampleRevoke', data);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new AccessData_1.default() })
], MainView.prototype, "dataSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MainView.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], MainView.prototype, "projectsFilter", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], MainView.prototype, "samplesFilter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('dataSet')
], MainView.prototype, "f", null);
MainView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            PreTable: PreTable_vue_1.default,
            MainTable: MainTable_vue_1.default,
            Pagination: bmk_ui_framework_1.Pagination,
            TableProjects: TableProjects_vue_1.default,
        },
    })
], MainView);
exports.default = MainView;
